import React from "react";
import * as MdIcons from "react-icons/md";

export const SidebarData = [
  {
    title: "Accueil",
    path: "/home",
    icon: <MdIcons.MdOutlineGridView />,
    cName: "nav-text",
  },
  {
    title: "Transactions",
    path: "/transactions",
    icon: <MdIcons.MdOutlineSwapHorizontalCircle />,
    cName: "nav-text",
  },
  {
    title: "Demande de paiement",
    path: "/paiement",
    icon: <MdIcons.MdOutlineUploadFile />,
    cName: "nav-text",
  },
  {
    title: "Rapports Journaliers",
    path: "/rapports-journaliers",
    icon: <MdIcons.MdOutlineFileDownload />,
    cName: "nav-text",
  },
  {
    title: "Rapport Mensuel",
    path: "/rapport-mensuel",
    icon: <MdIcons.MdOutlineAssignment />,
    cName: "nav-text",
  },
  {
    title: "Mes Gains Parrainage",
    path: "/parrainage",
    icon: <MdIcons.MdOutlinePersonAddAlt1 />,
    cName: "nav-text",
  },
  {
    title: "Clients",
    path: "/clients",
    icon: <MdIcons.MdOutlinePeopleAlt />,
    cName: "nav-text",
  },
  {
    title: "Info et Contacts",
    path: "/contact",
    icon: <MdIcons.MdOutlineInfo />,
    cName: "nav-text",
  },
  {
    title: "Paramètres",
    path: "/parametres",
    icon: <MdIcons.MdOutlineSettings />,
    cName: "nav-text",
  },
  {
    title: "Déconnexion",
    path: "/",
    icon: <MdIcons.MdLogout />,
    cName: "nav-text",
  },
];
